export const dentistryConst = {
  path: "/single-programs/dentistry",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ — СТОМАТОЛОГИЯ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> бакалавра, магистра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Стоматология — медицина точности и эстетики</h2>
      <p>
        Стоматология — это динамично развивающаяся область, сочетающая передовые медицинские технологии, точную хирургию и эстетический
        подход. Образование охватывает полную диагностику, профилактику и лечение заболеваний зубов, десен и полости рта, а также
        современные методы имплантации, ортодонтии и эстетической реставрации.
      </p>
      <p>
        Программа направлена на формирование клинических и технических навыков, необходимых для успешной карьеры в частной или
        государственной стоматологической практике.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Анатомия головы и шеи, стоматологическая физиология</li>
        <li>Терапевтическая и хирургическая стоматология</li>
        <li>Ортодонтия и протезирование</li>
        <li>Пародонтология и гигиена полости рта</li>
        <li>Имплантология и челюстно-лицевая хирургия</li>
        <li>Эстетическая стоматология и реставрация</li>
        <li>Радиология, 3D-моделирование и цифровые технологии</li>
        <li>Медицинская этика, коммуникация с пациентами</li>
        <li>Организация стоматологической практики и менеджмент</li>
      </ul>
      <p>Студенты получают практические навыки в клиниках, стоматологических кабинетах, лабораториях и учебных симуляционных центрах.</p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Врач-стоматолог общей практики</li>
        <li>Хирург-стоматолог</li>
        <li>Ортодонт</li>
        <li>Специалист по эстетической стоматологии</li>
        <li>Имплантолог</li>
        <li>Преподаватель или научный сотрудник</li>
        <li>Владелец частной стоматологической практики</li>
      </ul>
      <h2>Востребованность и доход</h2>
      <p>Стоматология входит в число самых высокооплачиваемых медицинских направлений.</p>
      <p>
        <strong>Средний доход в Европе — от €70,000 до €150,000 в год,</strong> особенно в частной практике и специализированных клиниках.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом бакалавра и магистра</li>
        <li>Обучение на русском и английском языках</li>
        <li>Очная и дистанционная формы обучения</li>
        <li>Современные симуляционные лаборатории и цифровые технологии</li>
        <li>Индивидуальные стажировки в клиниках Европы</li>
        <li>Поддержка на всех этапах — от поступления до трудоустройства</li>
      </ul>
      <h2>Учёба, которая приносит реальные навыки</h2>
      <p>
        Стоматология требует точности, уверенности и постоянного развития. Наши студенты получают не только знания, но и реальные
        клинические навыки, которые делают их востребованными специалистами по всему миру.
      </p>
      <br />
      <p className="padding-left">
        «Стоматология — это синтез науки, мастерства и эстетики. Мы готовим профессионалов, которые дарят людям уверенность и здоровье.»
      </p>
      <h2>Как поступить?</h2>
      <p>
        Пройдите простой путь: заполните онлайн-анкету, прикрепите документы — и мы свяжемся с вами. Приёмная комиссия сопроводит вас на
        каждом этапе поступления.
      </p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра, магистра
    Форма обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии

    Стоматология — медицина точности и эстетики
    Стоматология — это динамично развивающаяся область, сочетающая передовые медицинские технологии, точную хирургию и эстетический подход. Образование охватывает полную диагностику, профилактику и лечение заболеваний зубов, десен и полости рта, а также современные методы имплантации, ортодонтии и эстетической реставрации.
    Программа направлена на формирование клинических и технических навыков, необходимых для успешной карьеры в частной или государственной стоматологической практике.

    Что вы будете изучать?
    • Анатомия головы и шеи, стоматологическая физиология
    • Терапевтическая и хирургическая стоматология
    • Ортодонтия и протезирование
    • Пародонтология и гигиена полости рта
    • Имплантология и челюстно-лицевая хирургия
    • Эстетическая стоматология и реставрация
    • Радиология, 3D-моделирование и цифровые технологии
    • Медицинская этика, коммуникация с пациентами
    • Организация стоматологической практики и менеджмент
    Студенты получают практические навыки в клиниках, стоматологических кабинетах, лабораториях и учебных симуляционных центрах.

    Кем можно работать после окончания?
    • Врач-стоматолог общей практики
    • Хирург-стоматолог
    • Ортодонт
    • Специалист по эстетической стоматологии
    • Имплантолог
    • Преподаватель или научный сотрудник
    • Владелец частной стоматологической практики

    Востребованность и доход
    Стоматология входит в число самых высокооплачиваемых медицинских направлений.
    Средний доход в Европе — от €70,000 до €150,000 в год, особенно в частной практике и специализированных клиниках.

    Почему выбирают нас?
    • Европейский диплом бакалавра и магистра
    • Обучение на русском и английском языках
    • Очная и дистанционная формы обучения
    • Современные симуляционные лаборатории и цифровые технологии
    • Индивидуальные стажировки в клиниках Европы
    • Поддержка на всех этапах — от поступления до трудоустройства

    Учёба, которая приносит реальные навыки
    Стоматология требует точности, уверенности и постоянного развития. Наши студенты получают не только знания, но и реальные клинические навыки, которые делают их востребованными специалистами по всему миру.
    «Стоматология — это синтез науки, мастерства и эстетики. Мы готовим профессионалов, которые дарят людям уверенность и здоровье.»

    Как поступить?
    Пройдите простой путь: заполните онлайн-анкету, прикрепите документы — и мы свяжемся с вами. Приёмная комиссия сопроводит вас на каждом этапе поступления.
  `,
};
